import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import addGameDisposition from "./components/addGameDisposition";
export default {
  name: "gameDisposition",
  mixins: [loadMoreList, serchSelect],
  components: {
    addGameDisposition: addGameDisposition
  },
  data: function data() {
    return {
      pagingReqFn: "configurationData",
      pagingReqValue: "",
      tableBody: 'topBannerTable',
      sortReq: 'configurationChangeSort',
      drawer: false,
      content: ''
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    consynopsistentView: function consynopsistentView(row) {
      this.content = this.$utils.textRepl(row.synopsis);
      this.drawer = true;
    },
    del: function del(data) {
      var _this = this;

      var ids = data.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'configurationDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};